var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_LightningLayer = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_BaseLayer(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        debug: false,
        class_name: "LightningLayer",
        num_points: 0,
        options: {
            resolution: 1,
            size: 3,
            color: "#000000",
            title: 'Lightning (WDT)',
            useRetina: false,
            source_type: 'Lightning',
            style_type: 'lightning'
        },
        create: function () {
            var sm = this.get_style_manager();
            var layer_ops = {};
            var source = this.get_source();
            
            layer_ops.style = sm.get_layer_style_method();
            if (source) {
                //source.setStyle(sm.get_layer_style_method());
                layer_ops.source = source;
            }
            
            var layer = new ol.layer.Vector(layer_ops);
            //var layer = new ol.layer.Image(layer_ops);
            this.set_layer(layer);
            return layer;
        },
        create_layer_legend: function (contianer) {

        },
        set_source_obj: function (source) {
            // Verify the incoming source is what we are expecting
            if (source && source.class_type === "Source" && source.class_name === this.options.source_type + "Source") {
                this.source_obj = source;
                this.set_layer_source();
                if (this.source_obj.ready) {
                    this.ready();
                } else {
                    this.source_obj.addEvent('ready', this.ready.bind(this));
                }

            }
        },
        set_dateObj: function (dateObj) {
            if (!this.date_obj) {
                this.date_obj = dateObj;
            }
            var sm = this.get_style_manager();
            sm.set_datetime(dateObj);
        },        
        get_dateObj: function () {
            return this.date_obj;
        },
        get_timestamp_epoch: function () {
            return this.date_obj.get_current_epoch_time();
        },        
        display_debug_data: function () {
            /* istanbul ignore next */
            return this.num_points;
        },
        get_style_manager: function () {
            var sm = this.parent();
            // Done this way so that if a style type were to be applied that is seperate from the default, it does not get sabatoged by the default option when a new layer is created
            if (this.options.style_type && sm.get_style_type() === null) {
                sm.set_style_type(this.options.style_type);
            }
            
            return sm;
        }
    });
};
OCS.Viewer.Classes.LightningLayer = OCS.Viewer.Functions.define_LightningLayer();